<template>
  <div>
    <CCard style="margin-top: 20px">
      <CCardHeader>
        <h5><b>Betting</b></h5>
      </CCardHeader>
      <CCardBody>
        <CRow>
          <CCol sm="12">
            <CRow>
              <CCol sm="6">
                <label>Team 1</label>
                <CInput placeholder="Enter Quiz Title" v-model="Quiztitle" />
              </CCol>
              <CCol sm="6">
                <label>Team 2</label>
                <CInput
                  placeholder="Enter Quiz question"
                  v-model="Quizquestion"
                />
              </CCol>
              <CCol sm="4">
                <label>Betting option1</label>
                <CInput placeholder="Enter option1" v-model="option1" />
              </CCol>

              <CCol sm="4">
                <label>Betting option2</label>
                <CInput placeholder="Enter option2" v-model="option2" />
              </CCol>
              <CCol sm="4">
                <label>Betting option3</label>
                <CInput placeholder="Enter option3" v-model="option3" />
              </CCol>
              <!-- <CCol sm="3">
                <label>Quiz option4</label>
                <CInput placeholder="Enter option4" v-model="option4" />
              </CCol> -->

              <!-- <CCol sm="6">
                <label>Betting Answer</label>
                <CInput
                  placeholder="Enter Quiz Answer"
                  v-model.number="Quizanswer"
                  type="hidden"
                />
              </CCol> -->
               <!-- <CCol sm="6">
               </CCol> -->
              <!-- <CCol sm="6">
                <label>Quiz Point</label>
                <CInput
                  placeholder="Enter Quiz Point"
                  v-model.number="Quizpoint"
                />
              </CCol> -->

              <CCol sm="6">
                <!-- <datetime format="MM/DD/YYYY" width="300px" v-model="val"></datetime> -->
                <label>Start Date & Time</label> <br />
                <CCard v-if="enablepicker">
                  <CCardHeader>
                    <span>{{ this.editstarttime }}</span>
                    <CButton
                      @click="changepicker()"
                      color="success"
                      style="float: right"
                      >change</CButton
                    >
                  </CCardHeader>
                </CCard>

                <VueCtkDateTimePicker v-model="starttime" v-else />

                <br />
              </CCol>

              <CCol sm="6">
                <label>End Date & Time</label> <br />
                <CCard v-if="enablepicker">
                  <CCardHeader>
                    <span>{{ this.editendtime }}</span>
                    <CButton
                      @click="changepicker()"
                      color="success"
                      style="float: right"
                      >change</CButton
                    >
                  </CCardHeader>
                </CCard>

                <VueCtkDateTimePicker v-model="endtime" v-else />
                <br />
              </CCol>
              <CCol sm="6">
                <CCard>
                  <CCardHeader>
                    <span style="font-size: 14px; font-weight: bold"
                      >Status</span
                    >

                    <input
                      type="checkbox"
                      value="test"
                      v-model="status"
                      style="float: right; width: 113px; height: 22px"
                    />
                  </CCardHeader>
                </CCard>
              </CCol>
<CCol sm="6" v-if="isBonus">
                <label>Bonus Point</label>
                <CInput
                  placeholder="Enter Quiz Point"
                  v-model.number="bonus"
                />
              </CCol>
              <!-- <CCol sm="6">
                <CCard>
                  <CCardHeader>
                    <span style="font-size: 14px; font-weight: bold"
                      >Scramble</span
                    >

                    <input
                      v-model="scramble"
                      type="checkbox"
                      value="test"
                      style="float: right; width: 113px; height: 22px"
                    />
                  </CCardHeader>
                </CCard>
              </CCol>
              <CCol sm="6">
                <CCard>
                  <CCardHeader>
                    <span style="font-size: 14px; font-weight: bold">DFS</span>

                    <input
                      v-model="dfs"
                      type="checkbox"
                      value="test"
                      style="float: right; width: 113px; height: 22px"
                    />
                  </CCardHeader>
                </CCard>
              </CCol>
              <CCol sm="12">
                <CCard>
                  <CCardHeader>
                    <CRow>
                      <CCol sm="3"><h5>Choose type</h5> </CCol>
                      <CCol sm="2"
                        ><input
                          type="radio"
                          value="normal"
                          v-model="quiztype"
                        />&nbsp;<span style="font-size: large">Normal</span>
                      </CCol>
                      <CCol sm="3"
                        ><input
                          type="radio"
                          value="playAlong"
                          v-model="quiztype"
                        />&nbsp;<span style="font-size: large">Play Along</span>
                      </CCol>
                      <CCol sm="2"> </CCol>
                    </CRow>
                  </CCardHeader>
                </CCard>
              </CCol> -->
              <!-- <CCol sm="6">
                <CCard>
                  <CCardHeader>
                    <span style="font-size: 14px; font-weight: bold"
                      >Status</span
                    >

                    <input
                      type="checkbox"
                      value="test"
                      v-model="status"
                      style="float: right; width: 113px; height: 22px"
                    />
                  </CCardHeader>
                </CCard>
              </CCol>

              <CCol sm="6" v-if="dbdata=='DFS' ">
                <label>MatchID</label>
                <CInput placeholder="Enter MatchID" v-model.number="matchId" />
              </CCol>

              <CCol v-if="enableimg">
                <label> Quiz Image</label><br />
                <img
                  class="preview"
                  :src="QuizImage"
                  style="width: 150px; height: 150px"
                />
                <CButton @click="changeimg()" color="success">change</CButton>
              </CCol>
              <CCol sm="6" v-else>
                <div>
                  <div>
                    <label> Quiz Image </label>
                    <br />
                    <input
                      type="file"
                      @change="previewImage"
                      accept="image/*"
                    />
                  </div>
                  <div>
                    <p>
                      Progress: {{ uploadValue.toFixed() + "%" }}
                      <progress
                        id="progress"
                        :value="uploadValue"
                        max="100"
                      ></progress>
                    </p>

                    <CButton
                      color="success"
                      @click="onUpload()"
                      v-if="uploadbtn"
                      >Upload</CButton
                    >
                  </div>
                </div>
                <div v-if="imageData != null">
                  <img
                    class="preview"
                    :src="picture"
                    style="width: 300px; height: 300px"
                  />

                  <br />
                </div>
              </CCol> -->

              <CCol sm="12" style="text-align: center !important">
                <br /><br /><br />
                <CButton color="success" style="width: 20%" @click="update()"
                  >update</CButton
                >
              </CCol>
            </CRow>
          </CCol>
        </CRow>
      </CCardBody>
    </CCard>
  </div>
</template>
<script>
import Swal from "sweetalert2";
import firebase from "firebase";
const db = firebase.firestore();

import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";
const admin = require("firebase-admin");
import moment from "moment";
import { secondaryDatabase } from "./secondary.js";
const fieldValue = admin.firestore.FieldValue;
import axios from "axios";
export default {
  components: { VueCtkDateTimePicker },
  data() {
    return {
      Quiztitle: "",
      Quizquestion: "",
      option1: "",
      option2: "",
      option3: "",
      option4: "",
      Quizoptions: [],
      Quizanswer: "",
      QuizImage: "",
      Quizpoint: "",
      starttime: "",
      endtime: "",
      status: false,
      imageData: null,
      picture: null,
      uploadValue: 0,
      uploadbtn: false,
      quiztype: "",
      scramble: false,
      dfs: true,
      enableimg: false,

      enablepicker: false,
      editstarttime: "",
      editendtime: "",
      starttimestap: "",
      endtimestap: "",
      matchId: "",

      dbdata: false,
      // showmatch:false
    };
  },
  watch: {
    starttime() {
      this.starttimestap = firebase.firestore.Timestamp.fromDate(
        new Date(this.starttime)
      );
    },
    endtime() {
      this.endtimestap = firebase.firestore.Timestamp.fromDate(
        new Date(this.endtime)
      );
    },
  },
  methods: {
    changeimg() {
      this.enableimg = false;
    },
    changepicker() {
      this.enablepicker = false;
    },
    savequiz() {
      this.tableData = [];

  
        

        secondaryDatabase
          .collection("bettingtest")
          .doc(this.id)
          .get()
          .then((snapshot) => {
           
            (this.Quiztitle = snapshot.data().team1),
              (this.Quizquestion = snapshot.data().team2),
              (this.option1 = snapshot.data().options[0]),
              (this.option2 = snapshot.data().options[1]),
              (this.option3 = snapshot.data().options[2]),
            //   (this.option4 = snapshot.data().options[3]),
              (this.Quizanswer = snapshot.data().answer),
              (this.Quizpoint = snapshot.data().point),
              (this.QuizImage = snapshot.data().image),
              (this.status = snapshot.data().status),
              (this.quiztype = snapshot.data().quiztype),
              (this.scramble = snapshot.data().scramble),
              (this.dfs = snapshot.data().dfs),
              (this.matchId = snapshot.data().matchId);
              this.isBonus = snapshot.data().isBonus
              this.bonus = snapshot.data().bonus
            this.editstarttime = moment(
              snapshot.data().starttime.seconds * 1000
            ).format("DD-MMM-YYYY, h:mm:ss a");

            console.log("this.editstarttime", this.editstarttime);
            this.editendtime = moment(
              snapshot.data().endtime.seconds * 1000
            ).format("DD-MMM-YYYY, h:mm:ss a");

            console.log("this.editendtime", this.editendtime);

            // if (this.QuizImage.length > 0) {
            //   this.enableimg = true;
            // }
            if (this.editstarttime != "Invalid date") {
              this.enablepicker = true;
            }

           
          });
 
    },

    previewImage(event) {
      this.uploadValue = 0;
      this.picture = null;
      this.imageData = event.target.files[0];
      // if(this.imageData.length>0){
      this.uploadbtn = true;
      // }
    },

    onUpload() {
      this.picture = null;
      var timestamp = new Date().toISOString().replace(/[-:.]/g, "");
      var random = ("" + Math.random()).substring(2, 8);
      var random_number = timestamp + random;
      var fileextension = this.imageData.name.split(".")[1];

      const storageRef = firebase
        .storage()
        .ref(`tokenImages/${random_number}.${fileextension}`)
        .put(this.imageData);
      storageRef.on(
        `state_changed`,
        (snapshot) => {
          this.uploadValue =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        },
        (error) => {
          console.log(error.message);
        },
        () => {
          this.uploadValue = 100;
          storageRef.snapshot.ref.getDownloadURL().then((url) => {
            console.log("url5", url);
            this.picture = url;
            this.QuizImage = url;
            if (this.picture.length > 0) {
              this.uploadbtn = false;
            }
          });
        }
      );
    },
    update() {
      this.Quizoptions.push(
        this.option1,
        this.option2,
        this.option3,
        // this.option4
      );
   if (!this.enablepicker  && this.starttime == "") {
        Swal.fire({
          position: "center",
          icon: "warning",
          title: "Please Enter Starttime",
          showConfirmButton: false,
          timer: 3000,
        });
        return false;
      } else if (!this.enablepicker  && this.endtime == "") {
        Swal.fire({
          position: "center",
          icon: "warning",
          title: "Please Enter endtime",
          showConfirmButton: false,
          timer: 3000,
        });
        return false;
      }
       if (this.enablepicker) {
 secondaryDatabase
          .collection("bettingtest")
          .doc(this.id)
          .update({
            team1: this.Quiztitle,
            team2: this.Quizquestion,
            options: this.Quizoptions,
            // answer: this.Quizanswer,
            // point: this.Quizpoint,
            // image: this.QuizImage,
            status: this.status,
            // quiztype: this.quiztype,
            // scramble: this.scramble,
            dfs: this.dfs,
            // matchId: this.matchId,
            bonus:this.bonus
          })
          .then(() => {
              let messagetitle = this.Quiztitle + " vs " + this.Quizquestion +"Updated!";
          let messagetext = this.starttimestap
            ? this.Quiztitle + " vs " + this.Quizquestion +
              "  has been updated and will be active from " +
              moment(this.starttimestap.seconds * 1000).format(
                "DD-MMM-YYYY , hh:mm:ss:a"
              ) +
              " to " +
              moment(this.endtimestap.seconds * 1000).format(
                "DD-MMM-YYYY , hh:mm:ss:a"
              ) +
              " Answer quickly before it expires."
            : this.Quiztitle + " vs " + this.Quizquestion + " Answer quickly before it expires";
          let picture = "https://firebasestorage.googleapis.com/v0/b/token-geomine.appspot.com/o/tokenImages%2F20211023T111930708Z171255.png?alt=media&token=ae68d137-1906-4cf9-bdee-5f9d7e7e9013";
          let data = {
            messagetitle,
            messagetext,
            picture
          };
          axios.post("https://us-central1-token-geomine.cloudfunctions.net/dfs/sentQuizNotification", { ...data })
          // axios.post(
          //   "http://localhost:5000/token-geomine/us-central1/dfs/sentQuizNotification",
          //   { ...data }
          // );
            Swal.fire({
              position: "center",
              icon: "success",
              title: "Data Saved Successfully",
              showConfirmButton: false,
              timer: 3000,
            });
             this.$router.push({ name: "TableNft" });
          });
       }else{
          secondaryDatabase
          .collection("bettingtest")
          .doc(this.id)
          .update({
            quizTitle: this.Quiztitle,
            question: this.Quizquestion,
            options: this.Quizoptions,
            // answer: this.Quizanswer,
            // point: this.Quizpoint,
            // image: this.QuizImage,
            starttime: this.starttimestap,
            endtime: this.endtimestap,
            status: this.status,
            // quiztype: this.quiztype,
            // scramble: this.scramble,
            dfs: this.dfs,
            bonus:this.bonus
            // matchId: this.matchId,
          })
          .then(() => {
        //       let messagetitle = this.Quiztitle +" Updated!";
        //   let messagetext = this.starttimestap
        //     ? this.Quiztitle +
        //       "  has been updated and will be active from " +
        //       moment(this.starttimestap.seconds * 1000).format(
        //         "DD-MMM-YYYY , hh:mm:ss:a"
        //       ) +
        //       " to " +
        //       moment(this.endtimestap.seconds * 1000).format(
        //         "DD-MMM-YYYY , hh:mm:ss:a"
        //       ) +
        //       " Answer quickly before it expires."
        //     : this.Quiztitle + " Answer quickly before it expires";
        //   let picture = this.picture;
        //   let data = {
        //     messagetitle,
        //     messagetext,
        //     picture
        //   };
        //   axios.post("https://us-central1-token-geomine.cloudfunctions.net/dfs/sentQuizNotification", { ...data })
          // axios.post(
          //   "http://localhost:5000/token-geomine/us-central1/dfs/sentQuizNotification",
          //   { ...data }
          // );
            Swal.fire({
              position: "center",
              icon: "success",
              title: "Data Saved Successfully",
              showConfirmButton: false,
              timer: 3000,
            });
             this.$router.push({ name: "TableNft" });
          });
       }
    },
  },
  created() {
    this.id = this.$route.params.id;

    this.dbdata = this.$route.params.data;

    console.log("id received", this.id);
    console.log("data received", this.$route.params.data);

    this.savequiz();
  },
};
</script>